import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useState } from "react";
import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";
import { StockTableRow } from "./table/StockTableRow";
import { StockTablePagination } from "./table/StockTablePagination";

interface StockTableProps {
  items: any[];
  onAddToCart: (item: any, quantity: number) => void;
  refetch: () => void;
  onRestockClick: (item: any) => void;
  onReturnClick: (item: any) => void;
  buttonVisibility: {
    cart: boolean;
    restock: boolean;
    return: boolean;
    quantity: boolean;
    actions: boolean;
  };
}

export const StockTable = ({
  items,
  onAddToCart,
  refetch,
  onRestockClick,
  onReturnClick,
  buttonVisibility,
}: StockTableProps) => {
  const [quantities, setQuantities] = useState<{ [key: string]: number }>({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const { data: currency } = useOwnerCurrency();

  const handleQuantityChange = (itemId: string, value: string) => {
    const quantity = parseInt(value) || 0;
    setQuantities({ ...quantities, [itemId]: quantity });
  };

  const getItemQuantity = (itemId: string) => {
    return quantities[itemId] || 1;
  };

  const formatPrice = (price: string | number) => {
    if (!price) return `0 ${currency || 'FCFA'}`;
    
    if (typeof price === 'string') {
      const numericPrice = parseFloat(price.replace(/[^\d.-]/g, ''));
      return isNaN(numericPrice) ? `0 ${currency || 'FCFA'}` : `${numericPrice.toLocaleString()} ${currency || 'FCFA'}`;
    }
    return `${price.toLocaleString()} ${currency || 'FCFA'}`;
  };

  const totalPages = Math.ceil((items?.length || 0) / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = items?.slice(startIndex, endIndex) || [];

  return (
    <div className="space-y-4">
      <div className="w-full overflow-auto rounded-lg border">
        <Table>
          <TableHeader>
            <TableRow className="bg-siby-50">
              <TableHead className="whitespace-nowrap">Article</TableHead>
              <TableHead className="whitespace-nowrap">Quantité</TableHead>
              <TableHead className="whitespace-nowrap">Unité</TableHead>
              <TableHead className="whitespace-nowrap">Prix</TableHead>
              <TableHead className="whitespace-nowrap">Statut</TableHead>
              {buttonVisibility.actions && <TableHead className="text-right whitespace-nowrap">Actions</TableHead>}
            </TableRow>
          </TableHeader>
          <TableBody>
            {currentItems.map((item: any) => (
              <StockTableRow
                key={item.id}
                item={item}
                quantity={getItemQuantity(item.id)}
                onQuantityChange={(value) => handleQuantityChange(item.id, value)}
                onAddToCart={() => onAddToCart(item, getItemQuantity(item.id))}
                onRestock={() => onRestockClick(item)}
                onReturn={() => onReturnClick(item)}
                buttonVisibility={buttonVisibility}
                formatPrice={formatPrice}
              />
            ))}
          </TableBody>
        </Table>
      </div>

      <StockTablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};